module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown pull-right"
  }, [_c('div', {
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus uppercase"
  }), _vm._v(_vm._s(_vm.$t('template.attributes.variable')))]), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.variables), function(variable) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.addVariable(variable)
        }
      }
    }, [_vm._v(_vm._s(variable.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36348e7b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/variables_dropdown.vue
// module id = 1073
// module chunks = 1